import { ServerFetch } from '../main-model'

export default class ReceiptPaymentListModel extends ServerFetch {
    getReceiptPaymentListBy = (data) => this.authFetch({
        url: 'receipt-payment-list/getReceiptPaymentListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getLastReceiptPaymentListBy = (data) => this.authFetch({
        url: 'receipt-payment-list/getLastReceiptPaymentListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}